module.exports = __webpack_public_path__ + "img/hdzx_1.17feefea.png";